import Tabs from 'components/tabs';

/**
 * Табы в блоке акций.
 * @type {Element}
 */
const tabsAboutClass = Array.from(document.querySelectorAll('.j-tabs-about'));

if (tabsAboutClass) {
    tabsAboutClass.forEach((tab, index) => {
        const tabsAbout = new Tabs();

        tabsAbout.init({
            element             : `.j-tabs-about-${index}`,
            tabsItemClass       : '.about-tabs__button',
            tabsContentItemClass: '.j-about-tabs-item'
        });
    });
}
